import { Button, Form } from 'antd';
import Email from 'assets/Icons/email';
import ModalEmail, { IModalEmailFuncFinish, useModalEmailRef } from 'components/ModalEmail';
import { FEATURE_KEYS } from 'constants/Permission';
import paymentApis from 'features/payment/services/apis';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import styled from 'styled-components';
import toast from 'utils/toast';
import PermissionManager from 'widgets/PermissionVerify';

type Props = {
  billId?: string;
  defaultEmail?: string;
  small?: boolean;
  v2?: boolean;
  hook?: boolean;
  permission?: FEATURE_KEYS;
};
type Ref = {
  open: () => void;
};
export const useButtonTicketSendEmailRef = () => useRef<Ref>(null);
const ButtonTicketSendEmail = forwardRef<Ref, Props>(({ hook, v2, billId, defaultEmail, small, permission }, ref) => {
  const setLoadingPage = useSetLoadingPage();
  const [emailForm] = Form.useForm();
  const emailRef = useModalEmailRef();

  const onFormEmailFinish: IModalEmailFuncFinish = async (values) => {
    if (!billId) return;
    emailRef.current?.close();
    setLoadingPage(true);
    try {
      const res = await paymentApis.sendSMSEmailReceipt(billId, 'EMAIL', values.email);
      if (res.data.data) {
        toast.success(res.data?.message || 'Success');
      }
    } catch (error) { }
    finally {
      setLoadingPage(false);
    }
  };
  const onOpen = async () => {
    if (permission) {
      const result = await PermissionManager.verify(permission);
      if (!result || result?.skip) return emailRef.current?.open(defaultEmail || '');
      if (!result.verifyData) return;
      emailRef.current?.open(defaultEmail || '');
      return;
    }
    emailRef.current?.open(defaultEmail || '');
  };

  useImperativeHandle(ref, () => ({
    open: onOpen,
  }));

  return (
    <>
      {!hook && <EmailButton onClick={onOpen} icon={<Email fill='#2563eb'/>}>
        EMAIL
      </EmailButton>}
      <ModalEmail v2={v2} ref={emailRef} form={emailForm} onFinish={onFormEmailFinish} />
    </>
  );
});
ButtonTicketSendEmail.displayName = 'ButtonTicketSendEmail';
export default ButtonTicketSendEmail;

export const EmailButton = styled(Button)`
  height: 42px;
  padding: 0 12px;
  border-radius: 8px;
  font-family: 'Poppins';

  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #2563eb;
  font-weight: 600;
  display: flex;
  align-items: center;

  transition: all 0.2s ease;

  &:hover {
    background: #dbeafe !important;
    border-color: #60a5fa !important;
    color: #1d4ed8 !important;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.18);
  }

  &:active {
    transform: scale(0.98);
  }
`;